export default __webpack_public_path__ + "static/media/icon-temperature.28fabfb1.svg";